import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

function Footer({ onOpenQuote }) {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <p className="eyebrow footer-eyebrow">Trusted Since 2010</p>
            <h3>SAI VENKATESHWARA PACKAGES</h3>
            <p className="footer-copy">
              Premium corrugated and protective packaging engineered for industrial reliability, safe transit, and
              long-term client confidence.
            </p>
          </div>

          <div>
            <h4>Quick Links</h4>
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/about">About Us</Link>
              <Link to="/products">Products</Link>
              <Link to="/infrastructure">Infrastructure</Link>
              <Link to="/clients">Clients</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>

          <div>
            <h4>Contact Info</h4>
            <p>Plant 1: Sl.No 232/1B1, 232/2, 239/1
Pathakotta to Ramapura Road
Shoolagiri (Taluk), Krishnagiri (District)
Tamil Nadu - 635117</p>
            <p>Email: info@saivenkateshwarapackage.com</p>
            <p>Phone: +91 94435 11714 / +91 86674 31339</p>
          </div>

          <div className="footer-action-card">
            <h4>Need a Custom Packaging Solution?</h4>
            <p>Share your specification, dispatch volume, and delivery schedule. We will respond quickly.</p>
            <button type="button" className="btn btn-secondary" onClick={onOpenQuote}>
              Start Inquiry
            </button>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Sai Venkateshwara Packages. All rights reserved.</p>
          <p>ISO 9001:2015 focused manufacturing and dependable on-time dispatch.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
